<div class="w-[247px] bg-white text-ui-dark flex justify-between overflow-hidden">
  <div class="w-[calc(100%_-_24px)]">
    <h4
      class="font-semibold text-base whitespace-nowrap overflow-hidden text-ellipsis flex items-center"
      [class.h-6]="status() === eEntityStatus.Archived"
      [class.mb-1.5]="status() !== eEntityStatus.Archived"
    >
      @if (status() === eEntityStatus.Archived) {
        <i class="icon-add-to-archive text-ui-gray-100 text-3xl"></i>
      }

      @if (status() === eEntityStatus.Paused) {
        <i class="icon-offline text-ui-gray-100 text-3xl"></i>
      }

      @if (status() === eEntityStatus.Active) {
        @if (!criticalAndMajorSeverityCount() && !minorSeverityCount()) {
          <i class="icon-CheckCircleRounded text-ui-green-light text-3xl">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        }

        @if (criticalAndMajorSeverityCount() > 0) {
          <i class="icon-alert text-ui-red-50 text-3xl"></i>
        }

        @if (minorSeverityCount() > 0 && !criticalAndMajorSeverityCount()) {
          <i class="icon-warning text-ui-yellow-100 text-3xl"></i>
        }
      }

      <a
        class="inline-flex ml-1.5 text-sm"
        [class]="spaceLink().length ? 'hover:underline cursor-pointer' : 'cursor-default'"
        [routerLink]="spaceLink()"
      >{{ name() }}</a>
    </h4>

    @if (address()) {
      <p class="test-address font-semibold text-xs mb-1.5 whitespace-nowrap overflow-hidden text-ellipsis w-full text-ui-gray-100">
        {{ address() }}
      </p>
    }

    @if (status() === eEntityStatus.Active) {
      <div class="flex items-stretch mb-1.5 justify-start">
        <div>
          <p class="text-xs leading-4 mb-1 flex items-center">Incidents:</p>
          <div class="flex">
            @if (criticalAndMajorSeverityCount()) {
              <avs-incident-severity-count
                class="mr-2"
                [amount]="criticalAndMajorSeverityCount()"
                [severity]="eIncidentSeverity.CRITICAL"
              />
            }
            @if (minorSeverityCount()) {
              <avs-incident-severity-count
                [amount]="minorSeverityCount()"
                [severity]="eIncidentSeverity.MINOR"
              />
            }
          </div>
        </div>
        <div class="mx-2 my-1 border-l border-ui-gray-light"></div>
        <div>
          <p class="text-xs leading-4 mb-1 flex items-center">Devices:</p>
          @if (status() === eEntityStatus.Active) {
            <avs-status-count
              [active]="deviceActive()"
              [paused]="devicePaused()"
            />
          }
        </div>
      </div>
    }
  </div>
  <div class="w-6 flex flex-col justify-end">
    @if (spaceLink().length) {
      <a
        class="flex"
        [class.mb-2]="status() !== eEntityStatus.Archived"
        [routerLink]="spaceLink()"
      >
        <i class="icon-arrow-right text-ui-dark text-3xl"></i>
      </a>
    }
  </div>
</div>
